import state from './state';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/manual_calls/index.js